import DTOCriteria = namaTypes.DTOCriteria;
import ExpressionBuilder from "@/utils/criteria/ExpressionBuilder.ts";


export default class CriteriaBuilder
{
  criteria: DTOCriteria;
  lastExpression?: ExpressionBuilder;

  constructor() {
    this.criteria = {
      expressions: [],
      distinctValues: false,
      ownerType: ""
    } as DTOCriteria;
  }

  static create(): CriteriaBuilder {
    return new CriteriaBuilder();
  }

  distinct(): CriteriaBuilder {
    this.criteria.distinctValues = true;
    return this;
  }

  dummy() {
    return new ExpressionBuilder(this, true);
  }

  field(id: string) {
    return new ExpressionBuilder(this).field(id);
  }

  commitedBefore() {
    return new ExpressionBuilder(this).commitedBefore();
  }

  openBracket() {
    if (this.lastExpression == null)
      this.lastExpression = new ExpressionBuilder(this);
    return this.lastExpression.openBracket();
  }

  closeBracket() {
    return this.lastExpression!.closeBracket();
  }

  or() {
    return this.lastExpression!.or();
  }

  and() {
    if (!this.lastExpression)
      this.dummy();
    return this.lastExpression!.and();
  }

  create(owner: string) {
    let create = CriteriaBuilder.create();
    create.criteria.ownerType = owner;
    return create;
  }

  build() {
    return this.criteria;
  }
}
